import React, { useCallback, useState } from "react"

import { Tooltip } from "@coval/ui/tooltip"
import { Check, Copy } from "lucide-react"

import { useGridCell } from "./useGridCell"

interface TestCaseIdCellProps {
  id: string
  width: string
}

export const TestCaseIdCell: React.FC<TestCaseIdCellProps> = ({
  id,
  width,
}) => {
  const [copied, setCopied] = useState(false)

  const copyId = useCallback(() => {
    void navigator.clipboard.writeText(id).then(() => {
      setCopied(true)
      setTimeout(() => setCopied(false), 1500)
    })
  }, [id])

  const { cellProps } = useGridCell({
    ariaLabel: `Test case ID ${id}. Press Enter to copy.`,
    mode: "activate",
    onActivate: copyId,
  })

  return (
    <td
      {...cellProps}
      className="py-4 px-2 outline-none"
      style={{ width, maxWidth: width, minWidth: width, verticalAlign: "top" }}
    >
      <div className="group/id flex items-center gap-1 rounded">
        <Tooltip content={id}>
          <span className="font-mono text-xs text-coval-text-muted truncate">
            {id}
          </span>
        </Tooltip>
        <Tooltip content="Copy test case ID">
          <button
            type="button"
            onClick={(e) => {
              e.stopPropagation()
              copyId()
            }}
            className="shrink-0 p-1 rounded opacity-0 group-hover/id:opacity-100 transition-opacity hover:bg-coval-contrast/10"
            aria-label="Copy test case ID"
            tabIndex={-1}
          >
            {copied ? (
              <Check className="w-3 h-3 text-coval-success-text" />
            ) : (
              <Copy className="w-3 h-3 text-coval-text-muted" />
            )}
          </button>
        </Tooltip>
      </div>
    </td>
  )
}
